import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import { DataAPIBaliseRetour } from '../../data/DataAPIBaliseRetour';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheAPIBaliseRetour } from '../Fiche/FicheAPIBaliseRetour';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        int?        idAPI                                   id de l'API pour laquelle afficher les paramètres
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListAPIBaliseRetour extends Component {

    //static defaultProps = {};

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "IdAPIBaliseRetourParent";
        this._objetState = {
            items: [],
            itemActif: {},
            parentActif: {},
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />;
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des balises en cours..."
        });

        let chargementBalises = DataAPIBaliseRetour._chargementAPIBalisesRetour(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementBalises
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeBalises = responseFetch.reponseAPIobjet || [];
                    const stateTemp = { items: listeBalises };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    this.setState({ items: [] });
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });
    };

    _getColumns = () => {
        let columns = [
            {
                key: "idAPIBaliseRetour",
                minWidth: 20,
                maxWidth: 20,
                name: "#",
                onRender: (item) => {
                    const idAPIBaliseRetour = item.idAPIBaliseRetour;
                    return <span title={idAPIBaliseRetour} className="badge badge-secondary">{idAPIBaliseRetour}</span>;
                }
            },
            {
                key: "libelleBaliseRetour",
                name: "Libellé",
                onRender: (item) => {
                    const libelleBaliseRetour = item.libelleBaliseRetour;
                    return <span title={libelleBaliseRetour}>{libelleBaliseRetour}</span>;
                }
            },
            {
                key: "nomTableProvenance",
                minWidth: 200,
                maxWidth: 200,
                name: "Table",
                onRender: (item) => {
                    const nomTableProvenance = item.nomTableProvenance;
                    return <span title={nomTableProvenance}>{nomTableProvenance}</span>;
                }
            },
            {
                key: "nomChampProvenance",
                minWidth: 200,
                maxWidth: 200,
                name: "Champs",
                onRender: (item) => {
                    const nomChampProvenance = item.nomChampProvenance;
                    return <span title={nomChampProvenance}>{nomChampProvenance}</span>;
                }
            },
            {
                isSorted: true,
                isSortedDescending: true,
                key: "idAPIBaliseRetourParent",
                minWidth: 200,
                maxWidth: 200,
                name: "Parent",
                onRender: (item) => {
                    const { idAPIBaliseRetourParent, libelleBaliseRetourParent } = item;
                    return <Fragment>
                        <span title={idAPIBaliseRetourParent} className="badge badge-secondary mr-1">{idAPIBaliseRetourParent}</span>
                        <span title={libelleBaliseRetourParent}>{libelleBaliseRetourParent}</span>
                    </Fragment>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanelAPIBaliseRetour(true, item, {}, false)}
                        title="Consulter/modifer cette balise de retour"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "add",
                minWidth: 25,
                maxWidth: 25,
                name: "Ajouter une balise enfant",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Add" }}
                        onClick={this._togglePanelAPIBaliseRetour(true, { ...FicheAPIBaliseRetour.defaultProps, idAPI: item.idAPI }, item, false)}
                        title="Ajouter une balise enfant"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "delete",
                minWidth: 25,
                maxWidth: 25,
                name: "Supprimer",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialogSuppression(true, item)}
                        title="Supprimer cette balise de retour"
                    />;
                }
            },
        ];
        return columns;
    };

    _getFiltres = () => {
        const { idAPI } = this.props;
        let filtres = {};
        if (idAPI) filtres.idAPI = idAPI;
        return filtres;
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            },
        ];
    };

    _getItems = () => {
        const { idAPI } = this.props;
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            {
                key: "add",
                name: "Ajouter une balise de retour",
                iconProps: { iconName: "Add" },
                onClick: this._togglePanelAPIBaliseRetour(true, { ...FicheAPIBaliseRetour.defaultProps, idAPI }, {}, false)
            }
        ];
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _supprimer = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression du paramètre en cours..."
        });

        const { idAPI, idAPIBaliseRetour } = this.state.itemActif;
        let suppressionAPIBaliseRetour = DataAPIBaliseRetour._onSuppressionAPIBaliseRetour(idAPI, idAPIBaliseRetour);
        suppressionAPIBaliseRetour
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
        this._toggleDialogSuppression(false)();
    };

    _togglePanelAPIBaliseRetour = (isOpen, item, parent, rechargerLesDonnees) => () => {
        this.setState(
            {
                afficherPanelAPIBaliseRetour: isOpen,
                itemActif: item || {},
                parentActif: parent || {}
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _toggleDialogSuppression = (isOpen, item) => () => {
        this.setState({
            afficherDialogSuppression: isOpen,
            itemActif: item || {}
        });
    };

    componentDidMount = () => { this._chargementDonnees(); };

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    render = () => {

        const content = this._creationContent();
        const { afficherDialogSuppression, afficherPanelAPIBaliseRetour, itemActif, parentActif } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheAPIBaliseRetour
                {...itemActif}
                idAPIBaliseRetourParent={parentActif.idAPIBaliseRetour || itemActif.idAPIBaliseRetourParent}
                isOpen={afficherPanelAPIBaliseRetour}
                onDismiss={this._togglePanelAPIBaliseRetour(false, null, null, false)}
                onMiseAJour={this._togglePanelAPIBaliseRetour(false, null, null, true)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimer} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message="Confirmez-vous la suppression de cette balise de retour ?"
                onDismiss={this._toggleDialogSuppression(false)}
                titre="Suppression d'une balise de retour"
            >
                <strong>Attention : toutes les éventuelles balises de retour rattachées à la balise «&nbsp;{itemActif.libelleBaliseRetour}&nbsp;» seront également supprimées.</strong>
            </EUIDialog>

        </Fragment>;

    };

};